import React, { useEffect } from "react";
import { Container } from "components";
import { useParams, useNavigate } from "react-router-dom";
import api from "services/api";
import PaymentSuccess from "./PaymentSuccess";

const PaymentResult = () => {
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    Textnum();
  }, []);
  const Textnum = async () => {
    try {
      const queryParams = new URLSearchParams(window.location.search);
      const paymentResponse = {
        status: queryParams.get("status"),
        txnid: queryParams.get("txnid"),
      };
      console.log("paymentResponse", paymentResponse);
      console.log("Txnid:", queryParams.get("txnid"));
      // Check if the transaction is a renewal based on session storage
      const isRenewal = sessionStorage.getItem("isRenewal") === "true";
      console.log("Is this a renewal transaction?", isRenewal);
      let response;
      if (isRenewal) {
        response = await api.post("verify-renewal-txn", {
          txnid: paymentResponse.txnid,
        });
        console.log("Renewal Transaction Verified:", response);
      } else {
        response = await api.post("/verify-txn", {
          txnid: paymentResponse.txnid,
        });
        console.log("Regular Transaction Verified:", response);
      }

      // Reset the session state
      sessionStorage.setItem("isRenewal", "false");
      console.log("Is this a renewal transaction after?", isRenewal);

      console.log("response:", response);
    } catch (error) {
      console.log("Textnum error:", error);
    }
  };

  // If payment is successful, show the PaymentSuccess component
  if (params?.id === "success") {
    return <PaymentSuccess />;
  }

  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <h1 className="text-center">
            {params?.id === "failure" && "Payment Failed ,Please Try Again"}
          </h1>
          <div className="text-center w-100">
            <button
              className="btn btn-primary"
              onClick={() => {
                if (params?.id === "failure") {
                  navigate("/plans");
                }
              }}
            >
              {params?.id === "failure" ? "Go To Plans" : "Go To Plans"}
            </button>
          </div>
          <div className="content-backdrop fade"></div>
        </div>
      </div>
    </Container>
  );
};

export default PaymentResult;
